import axios from 'axios'
import {Message} from 'element-ui';
import host from '@/utils/host';

let instance = axios.create({ //请求统一实例
  baseURL: '',
  timeout: 30000
});

/**
 * 响应拦截器
 *
 */
instance.interceptors.response.use((response) => {

  if(response.config.url == '/ctl/cpcapi/exception/download_error_log_file'){
    if (response.data) {
      return response.data;
    }
  }
  if (response.data && response.data.retCode == "SUCCESS") {
    return response.data;
  } else {
    if (response.data.retCode == "NO_AUTH") {
      localStorage.clear();
      let casLogoutUrl = `${host.ssoBaseUrl}/logout?service=${host.baseUrl}/ctl/web/index`;
      window.location.href = casLogoutUrl;
    }
    if (response && response.data.message) {
      Message({
        message: response.data.message,
        type: 'error'
      });
    }
    return Promise.reject(response && response.data);
  }
}, error => {
  if (error.response) {
    if (error.response.status == 403) {
      Message({
        message: error.response.data.message,
        type: 'error'
      });
    }
    if (error.response.status == 400) {
      Message({
        message: error.response.data.message,
        type: 'error'
      });
    }
    if (error.response.status == 502) {
      Message({
        message: '服务请求没有响应',
        type: 'error'
      });
    }
    return Promise.reject(error.response);
  }
})

/**
 * 请求拦截器
 *
 */
instance.interceptors.request.use((config) => {
  if (config.method === 'post' || 'get') {
      config.headers.token = localStorage.getItem('token');
      config.headers.accountCode = localStorage.getItem('accountCode');
    // config.headers.token = 'ca6da89eb233cc479c45662f5f0ee72168310819';
    // config.headers.accountCode = '7304855974515192166';

  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

/**
 * 封装的共通post方法
 *
 * @param url
 * @param params
 * @param config
 * @returns {Promise<any>}
 */
export function post(url, params, config) {
  return instance.post(url, params, config);
}

/**
 * 封装的get方法
 *
 * @param url
 * @param params
 */
export function get(url, params, config) {
  return instance.get(url, {params, ...config})
}

export function delStorage() {
  localStorage.removeItem('user');
}



// WEBPACK FOOTER //
// ./src/utils/api.js